/* Suprimal store policy pages: tidy Shopify's policy text, build "On this page", reading progress. */
(function () {
  'use strict';
  var doc = document.querySelector('[data-sp-pol-doc]');
  if (!doc) return;
  var rte = doc.querySelector('.shopify-policy__body .rte') || doc.querySelector('.shopify-policy__body');
  if (!rte) return;

  function meaningful(n, dir) {
    var s = n ? n[dir] : null;
    while (s && s.nodeType === 3 && !s.textContent.replace(/ /g, ' ').trim()) s = s[dir];
    return s;
  }
  function sentence(t) {
    t = t.replace(/\s+/g, ' ').replace(/[:\s]+$/, '').trim();
    var letters = t.replace(/[^A-Za-z]/g, '');
    if (letters && letters === letters.toUpperCase()) {
      t = t.toLowerCase();
      t = t.charAt(0).toUpperCase() + t.slice(1);
    }
    return t;
  }

  // 1. The page title already sits in the hero: drop a repeated h1 at the top of the text
  var first = rte.firstElementChild;
  if (first && first.tagName === 'H1') first.remove();

  // 2. Move "Last updated: ..." into the hero chip
  var scan = Array.prototype.slice.call(rte.children, 0, 3);
  for (var i = 0; i < scan.length; i++) {
    var m = scan[i].textContent.replace(/ /g, ' ').trim().match(/^last\s+updated\s*:?\s*(.{3,40})$/i);
    if (m) {
      var chip = document.querySelector('[data-sp-pol-updated]');
      var date = document.querySelector('[data-sp-pol-date]');
      if (chip && date) { date.textContent = m[1].trim(); chip.hidden = false; }
      scan[i].remove();
      break;
    }
  }

  // 3. Policies written as one long paragraph: split on blank lines and turn bold lead-ins into headings
  Array.prototype.slice.call(rte.querySelectorAll(':scope > p')).forEach(function (p) {
    if (!p.querySelector('br')) return;
    var heads = [];
    Array.prototype.forEach.call(p.children, function (el) {
      if (el.tagName !== 'STRONG' && el.tagName !== 'B') return;
      var t = el.textContent.replace(/ /g, ' ').trim();
      if (!t || t.length > 90) return;
      var prev = meaningful(el, 'previousSibling'), next = meaningful(el, 'nextSibling');
      if (prev && prev.nodeName !== 'BR') return;
      if (next && next.nodeName !== 'BR') return;
      heads.push(el);
    });
    var nodes = Array.prototype.slice.call(p.childNodes);
    var out = [], cur = document.createElement('p'), brs = 0, single = heads.length > 0;
    function flush() {
      while (cur.firstChild && (cur.firstChild.nodeName === 'BR' || (cur.firstChild.nodeType === 3 && !cur.firstChild.textContent.replace(/ /g, ' ').trim()))) cur.removeChild(cur.firstChild);
      while (cur.lastChild && (cur.lastChild.nodeName === 'BR' || (cur.lastChild.nodeType === 3 && !cur.lastChild.textContent.replace(/ /g, ' ').trim()))) cur.removeChild(cur.lastChild);
      if (cur.textContent.replace(/ /g, ' ').trim() || cur.querySelector('img,a')) out.push(cur);
      cur = document.createElement('p');
    }
    for (var k = 0; k < nodes.length; k++) {
      var n = nodes[k];
      if (n.nodeName === 'BR') {
        brs++;
        if (single || brs >= 2) { flush(); brs = 0; } else cur.appendChild(n);
        continue;
      }
      if (n.nodeType === 3 && !n.textContent.replace(/ /g, ' ').trim()) { cur.appendChild(n); continue; }
      brs = 0;
      if (heads.indexOf(n) !== -1) {
        flush();
        var h = document.createElement('h3');
        h.textContent = sentence(n.textContent);
        out.push(h);
        while (nodes[k + 1] && nodes[k + 1].nodeType === 3 && !nodes[k + 1].textContent.replace(/ /g, ' ').trim()) k++;
        if (nodes[k + 1] && nodes[k + 1].nodeName === 'BR') k++;
        continue;
      }
      cur.appendChild(n);
    }
    flush();
    if (out.length > 1 || heads.length) {
      var frag = document.createDocumentFragment();
      out.forEach(function (o) { frag.appendChild(o); });
      p.parentNode.replaceChild(frag, p);
    }
  });

  // 4. "On this page"
  var hs = Array.prototype.slice.call(rte.querySelectorAll('h2, h3'));
  var toc = document.querySelector('[data-sp-pol-toc]');
  var list = document.querySelector('[data-sp-pol-toc-list]');
  var used = {};
  hs.forEach(function (h) {
    if (!h.id) {
      var base = (h.textContent || 'section').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'section';
      var id = base, c = 2;
      while (used[id] || document.getElementById(id)) id = base + '-' + (c++);
      used[id] = 1;
      h.id = id;
    }
  });
  if (toc && list && hs.length >= 3) {
    var links = hs.map(function (h) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.replace(/\s+/g, ' ').trim();
      li.appendChild(a);
      list.appendChild(li);
      return a;
    });
    toc.hidden = false;
    if (window.matchMedia('(max-width: 900px)').matches) toc.open = false;
    list.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a) return;
      var t = document.getElementById(a.getAttribute('href').slice(1));
      if (!t) return;
      e.preventDefault();
      t.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      history.replaceState(null, '', '#' + t.id);
      if (window.matchMedia('(max-width: 900px)').matches) toc.open = false;
    });
    if ('IntersectionObserver' in window) {
      var active = null;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var idx = hs.indexOf(en.target);
          if (idx < 0 || links[idx] === active) return;
          if (active) active.classList.remove('is-active');
          active = links[idx];
          active.classList.add('is-active');
          var box = active.closest('.sp-pol__sticky');
          if (box && box.scrollHeight > box.clientHeight) {
            var r = active.getBoundingClientRect(), b = box.getBoundingClientRect();
            if (r.top < b.top + 40 || r.bottom > b.bottom - 20) box.scrollTop += r.top - b.top - b.height / 2;
          }
        });
      }, { rootMargin: '-18% 0px -72% 0px' });
      hs.forEach(function (h) { io.observe(h); });
    }
  }

  // 5. On phones the policy list is a sideways row: bring the current policy into view
  var navRow = document.querySelector('.sp-pol__nav');
  var curLink = navRow && navRow.querySelector('.is-current');
  if (navRow && curLink && navRow.scrollWidth > navRow.clientWidth) {
    navRow.scrollLeft = Math.max(0, curLink.offsetLeft - navRow.offsetLeft - (navRow.clientWidth - curLink.offsetWidth) / 2);
  }

  // 6. Reading progress + back to top
  var bar = document.querySelector('[data-sp-pol-bar]');
  var ticking = false;
  function progress() {
    ticking = false;
    if (!bar) return;
    var r = doc.getBoundingClientRect();
    var total = r.height - window.innerHeight * 0.6;
    var done = Math.min(1, Math.max(0, (-r.top + window.innerHeight * 0.2) / (total > 0 ? total : 1)));
    bar.style.transform = 'scaleX(' + done.toFixed(4) + ')';
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(progress); } }, { passive: true });
  window.addEventListener('resize', progress);
  progress();
  var top = document.querySelector('[data-sp-pol-top]');
  if (top) top.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    var h1 = document.querySelector('.sp-pol-hero__title');
    if (h1) { h1.setAttribute('tabindex', '-1'); h1.focus({ preventScroll: true }); }
  });
  if (location.hash) {
    var target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
    if (target) setTimeout(function () { target.scrollIntoView({ block: 'start' }); }, 60);
  }
})();